import Button from '../../../components/Button';
import { formShell } from '../../../styles/formShell';
import { aiChatShell } from '../../../styles/aiChatShell';

/**
 * チャット入力コンポーネント
 */
export default function ChatInput({
    input,
    onInputChange,
    onSubmit,
    onKeyDown,
    loading,
    purging,
    isTurnLimitReached,
    maxTurns,
    textareaRef,
    formRef,
    isWsConnected,
    openingFetching,
    sendDisabled = false
}) {
    return (
        <div className={aiChatShell.formWrap}>
            <form onSubmit={onSubmit} className={aiChatShell.form} ref={formRef}>
                <textarea
                    ref={textareaRef}
                    className={`${formShell.textarea} ${aiChatShell.textarea}`}
                    value={input}
                    onChange={(e) => onInputChange(e.target.value)}
                    onKeyDown={onKeyDown}
                    placeholder={
                        sendDisabled
                            ? "このモデルでは現在チャットをご利用いただけません。"
                            : (isTurnLimitReached && !loading
                                ? `最大${maxTurns}ターンに達しました。これ以上の会話はできません。`
                                : "会話してみましょう")
                    }
                    rows={1}
                    disabled={loading || purging || openingFetching || isTurnLimitReached || sendDisabled}
                    aria-describedby="aichat-safety-notice"
                />
                <Button
                    type="submit"
                    variant="primary"
                    size="cta"
                    disabled={loading || purging || openingFetching || !input.trim() || isTurnLimitReached || sendDisabled}
                    className={aiChatShell.formSubmit}
                >
                    {loading ? "送信中..." : "送信"}
                </Button>
            </form>
            <div
                id="aichat-safety-notice"
                className={aiChatShell.safetyNotice}
                role="note"
            >
                <span className={aiChatShell.safetyNoticeIcon} aria-hidden="true">
                    info
                </span>
                <div className={aiChatShell.safetyNoticeBody}>
                    <p>
                        AIの答えは、いつも正しいとはかぎりません。自分でよく考え、先生に確かめることが大切です。
                    </p>
                    <p>また、名前や電話番号など個人情報は書き込まないようにしましょう。</p>
                </div>
            </div>
        </div>
    );
}
